import { io as ioClient } from 'socket.io-client';

let socket = null;

export function connectSocket() {
  if (socket) return socket;
  const url = process.env.REACT_APP_API_URL;
  socket = ioClient(url, { autoConnect: true });
  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
